module.exports = __webpack_public_path__ + "img/img_web_menu_feature1.54ae4c58.png";